module.exports = __webpack_public_path__ + "img/ring_skip_skip_null_null@3x.cc7b712c.png";